import { SubmitOrderBlockReason } from './enums';

// Translation keys per SubmitOrderBlockReason. Keyed on the enum so a new reason cannot silently
// inherit another reason's copy — a timed-out order must never read "sent for processing".
// Short copy, for the parts-page button's disabled tooltip.
export const submitOrderBlockTooltipKeyMap: Record<SubmitOrderBlockReason, string> = {
  [SubmitOrderBlockReason.ALREADY_SUBMITTED]: 'tooltipOrderAlreadySubmittedExternal',
  [SubmitOrderBlockReason.ORDERING]: 'tooltipOrderingInProgress',
  [SubmitOrderBlockReason.SUBMISSION_TIMED_OUT]: 'tooltipSubmissionTimedOut',
};

// Full copy, for the drawer's alert.
export const submitOrderBlockMessageKeyMap: Record<SubmitOrderBlockReason, string> = {
  [SubmitOrderBlockReason.ALREADY_SUBMITTED]: 'messageSubmitOrderAlreadySubmittedExternal',
  [SubmitOrderBlockReason.ORDERING]: 'messageSubmitOrderOrderingInProgress',
  [SubmitOrderBlockReason.SUBMISSION_TIMED_OUT]: 'messageSubmitOrderSubmissionTimedOut',
};
